@if (showSortControls() && !isMobile()) {
  <proffeo-task-sort-controls
    [compact]="compactMode()"
    class="flex w-full shrink-0 pb-2"
  />
}

<div class="task-active-config">
  @if (showTreeControls()) {
    <button
      (click)="collapseTree()"
      [attr.aria-label]="'task-tree-collapse-all' | translate"
      [disabled]="!canCollapseTree()"
      [matTooltip]="'task-tree-collapse-all' | translate"
      type="button"
      class="task-tree-action"
    >
      <mat-icon
        [fontIcon]="canCollapseTree() ? 'expand_more' : 'chevron_right'"
        aria-hidden="true"
        class="icon-md"
      />
      <mat-icon
        aria-hidden="true"
        fontIcon="subdirectory_arrow_right"
        class="task-tree-symbol icon-xs"
      />
    </button>
  }
  <div class="task-config-chip task-grouping-chip">
    <proffeo-ui-select
      (valueChange)="changeGrouping($event)"
      [value]="mobileGrouping()"
      [options]="groupingOptions"
      [showTriggerChevron]="false"
      [triggerTemplate]="groupingChipTrigger"
      appearance="inline"
      class="task-config-select task-grouping-select"
    />
    <ng-template
      #groupingChipTrigger
      let-selectedOptions="selectedOptions"
    >
      <span class="task-config-label">{{ 'task-list-group' | translate }}:</span>
      <strong class="task-config-value">
        {{ $safeNavigationMigration(selectedOptions[0]?.label) | translate }}
      </strong>
      <mat-icon
        aria-hidden="true"
        fontIcon="expand_more"
        class="task-config-chevron"
      />
    </ng-template>
    @if (grouping() !== 'none') {
      <button
        (click)="toggleAllGroups()"
        [attr.aria-label]="groupToggleAction().label | translate"
        [matTooltip]="groupToggleAction().label | translate"
        type="button"
        class="task-config-action task-grouping-toggle"
      >
        <mat-icon
          [fontIcon]="groupToggleAction().icon"
          class="icon-md"
        />
      </button>
    }
  </div>
  <proffeo-task-sort-controls
    [chip]="true"
    class="task-sort-chip"
  />
</div>

<div
  [class.gap-2]="!isMobileCompact()"
  [proffeoSpinner]="listLoading()"
  proffeoSpinnerSize="md"
  class="relative flex flex-col min-h-24 w-full task-list-loading"
>
  @if (grouping() !== 'none') {
    @for (group of groupViews(); track group.id; let groupIndex = $index) {
      <section class="task-group-section min-w-0 w-full">
        <button
          (click)="toggleGroup(group.id)"
          [attr.aria-controls]="'task-group-' + groupIndex"
          [attr.aria-expanded]="group.expanded"
          type="button"
          class="task-group-heading flex w-full items-center gap-2 px-2 py-2 text-left"
        >
          <mat-icon
            [fontIcon]="group.expanded ? 'expand_more' : 'chevron_right'"
            class="shrink-0 icon-sm"
          />
          <span class="task-group-label min-w-0 flex-1">
            {{ group.translateLabel ? (group.label | translate) : group.label }}
          </span>
          <span class="shrink-0">{{ group.tasks.length }}</span>
        </button>
        @if (group.expanded) {
          <div
            [id]="'task-group-' + groupIndex"
            class="task-group-body flex flex-col"
          >
            @for (task of group.tasks; track task.id) {
              <ng-container
                [ngTemplateOutlet]="taskRow"
                [ngTemplateOutletContext]="{ $implicit: task }"
              />
            }
          </div>
        }
      </section>
    }
  } @else {
    @for (task of tasks(); track task.id) {
      <ng-container
        [ngTemplateOutlet]="taskRow"
        [ngTemplateOutletContext]="{ $implicit: task }"
      />
    }
  }
  @if (isEmpty()) {
    <div class="py-10 text-center text-proffeo-muted">{{ 'project-tasks.list.no-tasks' | translate }}</div>
  }
</div>
<ng-template
  #taskRow
  let-task
>
  <proffeo-task-splitview-list-item
    [(expandedNodes)]="expandedNodes"
    (statusChanged)="statusChanged.emit($event)"
    (priorityChanged)="priorityChanged.emit($event)"
    (taskStartDateSelected)="taskStartDateSelected.emit($event)"
    (taskEndDateSelected)="taskEndDateSelected.emit($event)"
    (taskProgressSelected)="taskProgressSelected.emit($event)"
    (industryClicked)="industryClicked.emit($event)"
    (locationClicked)="locationClicked.emit($event)"
    (changeGroupClicked)="changeGroupClicked.emit($event)"
    (changeUsersClicked)="changeUsersClicked.emit($event)"
    [task]="task"
    [compactMode]="compactMode()"
    [mobileCompact]="mobileCompact()"
    [hasChildren]="(task.subtasksCount ?? 0) > 0"
    [taskTypes]="taskTypes()"
    class="task-list-root-row"
  />
</ng-template>
